export const extractCriteriaIds = criteria => {
    if (!Array.isArray(criteria) || criteria.length === 0) {
        return { categoryIds: [], productIds: [] };
    }

    const categoryIds = [];
    const productIds = [];

    criteria.forEach(group => {
        if (group.baseOption === 'product_categories' && Array.isArray(group.baseValue)) {
            categoryIds.push(...group.baseValue);
        }
        if (group.baseOption === 'single_product' && (typeof group.baseValue === 'number' || typeof group.baseValue === 'string')) {
            productIds.push(group.baseValue);
        }

        if (group.subgroups) {
            group.subgroups.forEach(subgroup => {
                if (subgroup.rows) {
                    subgroup.rows.forEach(row => {
                        if (row.option === 'product_categories' && Array.isArray(row.value)) {
                            categoryIds.push(...row.value);
                        }
                        if (row.option === 'single_product' && (typeof row.value === 'number' || typeof row.value === 'string')) {
                            productIds.push(row.value);
                        }
                    });
                }
            });
        }
    });

    return {
        categoryIds: [...new Set(categoryIds)],
        productIds: [...new Set(productIds)],
    };
};
